/**
 * Student Hub Analytics — convenience helpers for tracking Student Hub events.
 * Uses the existing analytics utility (utils/analytics.js) and backend /api/analytics/event.
 * Does NOT introduce a new analytics system.
 */

import { trackEvent } from './analytics';

/** Fired when the Student Hub landing page is opened */
export const trackStudentHubOpened = (level) =>
  trackEvent('studenthub_opened', { academic_level: level || 'none' });

/** Fired when user selects or changes their academic level */
export const trackLevelSelected = (level, isEdit) =>
  trackEvent('studenthub_level_selected', { level, is_edit: !!isEdit });

/** Fired when user clicks Books & Notes category */
export const trackBooksClicked = () =>
  trackEvent('studenthub_books_clicked');

/** Fired when user clicks Courses & Learning category */
export const trackCoursesClicked = () =>
  trackEvent('studenthub_courses_clicked');

/** Fired when user clicks Scholarships category */
export const trackScholarshipsClicked = () =>
  trackEvent('studenthub_scholarships_clicked');

/** Fired when user clicks Internships & Jobs category */
export const trackInternshipsClicked = () =>
  trackEvent('studenthub_internships_clicked');

/**
 * Map category slug → analytics tracker
 * Only the 4 explicitly requested events are mapped.
 */
const CATEGORY_TRACKERS = {
  books: trackBooksClicked,
  courses: trackCoursesClicked,
  scholarships: trackScholarshipsClicked,
  internships: trackInternshipsClicked,
};

/** Fire the analytics event for a category click (no-op for unmapped categories) */
export const trackCategoryClicked = (slug) => {
  const tracker = CATEGORY_TRACKERS[slug];
  if (tracker) tracker();
};
